// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1uJLY","left":"StickyBox_left__19G15","right":"StickyBox_right__2FVrG"};